import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
interface TestimonialCardProps {
  testimonial: Testimonial;
}
export function TestimonialCard({
  testimonial
}: TestimonialCardProps) {
  return <div className="flex h-full flex-col rounded-2xl bg-white/90 p-8 shadow-soft backdrop-blur-sm" data-id="element-389" data-mp="2p884l1komcda">
      <Quote size={28} strokeWidth={1} className="mb-5 text-rose-600" aria-hidden="true" data-id="element-390" data-mp="2u7b09verv68l" />
      <p className="mb-6 flex-grow font-serif text-lg italic leading-relaxed text-charcoal" data-id="element-391" data-mp="2z4kv5qkxka3t">
        “{testimonial.excerpt}”
      </p>
      <div className="flex items-center justify-between border-t border-cream-200 pt-5" data-id="element-392" data-mp="3434jfxmzxxzc">
        <div data-id="element-393" data-mp="384gc6c162zbr">
          <p className="font-serif text-lg leading-tight text-charcoal" data-id="element-394" data-mp="3847w6b9qzdwc">
            {testimonial.name}
          </p>
          {testimonial.location && <p className="mt-0.5 text-xs tracking-wide text-charcoal-50" data-id="element-395" data-mp="1dtb1wovkrong">
              {testimonial.location}
            </p>}
        </div>
        <Link to={`/testimonials#${testimonial.id}`} className="group inline-flex items-center text-sm text-sage-700 transition-colors hover:text-sage-600" data-id="element-396" data-mp="d249mwpcbedi">
          Read more
          <ArrowRight size={14} strokeWidth={1.5} className="ml-1.5 transform transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-397" data-mp="346qgnmc87rr" />
        </Link>
      </div>
    </div>;
}